import { RegistrationLocale } from './registrationSlice';

export const buildRegistrationContext = ({
  accountNumber,
  countryCode = RegistrationLocale.US,
}: {
  accountNumber: string;
  countryCode?: RegistrationLocale;
}) => {
  const schema = 'registration_context';
  return {
    schema,
    data: {
      account_number: accountNumber,
      country: countryCode,
    },
  };
};
